export const countryLanguageMapping = {
  AU: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  BD: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  BN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  KH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  CN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  CK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  FJ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  HK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  IN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  ID: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  KR: [
    {
      label: "Korean",
      value: "Korean",
    },
  ],
  LA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MY: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MV: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  MM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  NP: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  NZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  PK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  PG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  PH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  WS: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  SG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  SB: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  LK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  TW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  TH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  VN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "Chinese",
      value: "Chinese",
    },
  ],
  AF: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AL: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  DZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AD: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BY: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BJ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BF: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  BI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CV: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CF: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TD: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  HR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CY: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  DK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  DJ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  EG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GQ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ER: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  EE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ET: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  FO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  FI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  FR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  DE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  HU: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  IS: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  IQ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  IE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  IL: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  IT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  JO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KV: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  KG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LV: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LB: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LS: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LY: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  LU: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ML: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MU: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  YT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MD: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MC: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ME: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  NA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  NL: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  NE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  NG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  MK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  NO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  OM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  PL: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  PT: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  QA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  RE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  RO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  RU: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  RW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ST: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  RS: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SC: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SL: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SK: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SI: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SO: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ZA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ES: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  SE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  CH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TJ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TN: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TR: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  TM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  UG: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  UA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  AE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  GB: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  UZ: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  VA: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  EH: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  YE: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ZM: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  ZW: [
    {
      label: "English",
      value: "English",
    },
    {
      label: "German",
      value: "German",
    },
    {
      label: "Italian",
      value: "Italian",
    },
    {
      label: "French",
      value: "French",
    },
    {
      label: "Spanish",
      value: "Spanish",
    },
  ],
  JP: [
    {
      label: "Japanese",
      value: "Japanese",
    },
  ],
  AI: [
    {
      label: "English",
      value: "English",
    },
  ],
  AQ: [
    {
      label: "English",
      value: "English",
    },
  ],
  AG: [
    {
      label: "English",
      value: "English",
    },
  ],
  AR: [
    {
      label: "English",
      value: "English",
    },
  ],
  AW: [
    {
      label: "English",
      value: "English",
    },
  ],
  BS: [
    {
      label: "English",
      value: "English",
    },
  ],
  BB: [
    {
      label: "English",
      value: "English",
    },
  ],
  BZ: [
    {
      label: "English",
      value: "English",
    },
  ],
  BM: [
    {
      label: "English",
      value: "English",
    },
  ],
  BO: [
    {
      label: "English",
      value: "English",
    },
  ],
  BR: [
    {
      label: "English",
      value: "English",
    },
  ],
  KY: [
    {
      label: "English",
      value: "English",
    },
  ],
  CL: [
    {
      label: "English",
      value: "English",
    },
  ],
  CO: [
    {
      label: "English",
      value: "English",
    },
  ],
  CR: [
    {
      label: "English",
      value: "English",
    },
  ],
  DM: [
    {
      label: "English",
      value: "English",
    },
  ],
  DO: [
    {
      label: "English",
      value: "English",
    },
  ],
  EC: [
    {
      label: "English",
      value: "English",
    },
  ],
  SV: [
    {
      label: "English",
      value: "English",
    },
  ],
  FK: [
    {
      label: "English",
      value: "English",
    },
  ],
  GF: [
    {
      label: "English",
      value: "English",
    },
  ],
  GD: [
    {
      label: "English",
      value: "English",
    },
  ],
  GP: [
    {
      label: "English",
      value: "English",
    },
  ],
  GT: [
    {
      label: "English",
      value: "English",
    },
  ],
  GY: [
    {
      label: "English",
      value: "English",
    },
  ],
  HT: [
    {
      label: "English",
      value: "English",
    },
  ],
  HN: [
    {
      label: "English",
      value: "English",
    },
  ],
  JM: [
    {
      label: "English",
      value: "English",
    },
  ],
  MQ: [
    {
      label: "English",
      value: "English",
    },
  ],
  MX: [
    {
      label: "English",
      value: "English",
    },
  ],
  MS: [
    {
      label: "English",
      value: "English",
    },
  ],
  AN: [
    {
      label: "English",
      value: "English",
    },
  ],
  NI: [
    {
      label: "English",
      value: "English",
    },
  ],
  PA: [
    {
      label: "English",
      value: "English",
    },
  ],
  PY: [
    {
      label: "English",
      value: "English",
    },
  ],
  PE: [
    {
      label: "English",
      value: "English",
    },
  ],
  PR: [
    {
      label: "English",
      value: "English",
    },
  ],
  SH: [
    {
      label: "English",
      value: "English",
    },
  ],
  KN: [
    {
      label: "English",
      value: "English",
    },
  ],
  LC: [
    {
      label: "English",
      value: "English",
    },
  ],
  VC: [
    {
      label: "English",
      value: "English",
    },
  ],
  GS: [
    {
      label: "English",
      value: "English",
    },
  ],
  SR: [
    {
      label: "English",
      value: "English",
    },
  ],
  TT: [
    {
      label: "English",
      value: "English",
    },
  ],
  TC: [
    {
      label: "English",
      value: "English",
    },
  ],
  UM: [
    {
      label: "English",
      value: "English",
    },
  ],
  UY: [
    {
      label: "English",
      value: "English",
    },
  ],
  VE: [
    {
      label: "English",
      value: "English",
    },
  ],
  VG: [
    {
      label: "English",
      value: "English",
    },
  ],
  AS: [
    {
      label: "English",
      value: "English",
    },
  ],
  CA: [
    {
      label: "English",
      value: "English",
    },
  ],
  US: [
    {
      label: "English",
      value: "English",
    },
  ],
};

export default countryLanguageMapping;
